const commonTheme = {
  // =============== FONT SIZES ===============
  font: {
    heading: {
      "2xs": `
        font-size:  14px ;
        line-height: 20px;
        letter-spacing: 2%; 
      `,
      xs: `
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 2%; 
      `,
      x: `
        font-size: 20px;
        line-height: 24px; 
      `,
      sm: `
        font-size: 28px;
        line-height: 32px;
      `,
      md: `
        font-size: 40px;
        line-height: 48px;
      `,
      lg: `
        font-size: 56px;
        line-height: 64px;
      `,
      xl: `
        font-size: 72px;
        line-height: 80px;
      `,
    },
    body: {
      xs: `
        font-size: 10px;
        line-height: 16px;
        letter-spacing: 2%; 
      `,
      x: `
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 2%; 
      `,
      sm: `
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 2%;
      `,
      md: `
        font-size: 16px;
        line-height: 20px;
        letter-spacing: 2%;
      `,
      lg: `
        font-size: 20px;
        line-height: 24px;
      `,
      xl: `
        font-size: 24px;
        line-height: 28px;
      `,
    },
    support: {
      x: `
        font-size: 8px;
        line-height: 16px;
        letter-spacing: 2%; 
      `,
      sm: `
        font-size: 10px;
        line-height: 16px;
        letter-spacing: 2%; 
      `,
      md: `
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 2%;
      `,
      lg: `
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 2%;
      `,
      xl: `
        font-size: 16px;
        line-height: 20px;
        letter-spacing: 2%;
      `,
    },
    weight: {
      light: "300",
      regular: "400",
      medium: "500",
      bold: "700",
    },
  },
  // =============== COLORS ===============
  colors: {
    primary: {
      BG: "#000000",
      prim50: "#BA91E3",
      prim100: "#A364E3",
      prim200: "#6419AF",
      prim300: "#4B197D",
      prim400: "#2A0B4A",
      cetaceanBlue: "rgb(50, 49, 51)",
      springGreen: "rgb(255, 196, 76)",
      vividCerulean: "rgb(76, 89, 128)",
      vividBlue: "#009EFF",
      orange: "#FF520B",
      green: "#B2CF63",
      blue: "#0016E2",
    },
    feedback: {
      success: "#0C802D",
      error: "#A81423",
    },
    neutral: {
      white: "#FFFFFF",
      cinza50: "#F0F0F0",
      cinza80: "#4A4A4A",
      cinza100: "#D0D0D0",
      cinza200: "#B9B9B9",
      cinza500: "#666666",
      cinza600: "#5D5D5D",
      cinza800: "#383838",
      cinza900: "#2B2B2B",
      cinza950: "#1c1c1c",
      secondary40: "#B3BDC4",
      black: "#000000",
      black2: "#000000",
    },
    level: {
      bg1: "#07F49E",
      bg2: "#8F4DF7",
      bg3: "#4CC9F0",
      bg4: "#4361EE",
    },

    //Cores antigas
    gradient: {
      gradientLogo:
        "linear-gradient(50deg, rgba(255,209,117,1) 0%, rgba(50,49,51,1) 100%);",
      gradientSpring:
        "linear-gradient(50deg, rgba(255,209,117,1) 0%, rgba(50,49,51,1) 100%);",
      gradientVivid:
        "linear-gradient(50deg, rgba(255,209,117,1) 0%, rgba(50,49,51,1) 100%);",
    },
    hues: {
      cetaceanShade1: "#0A143C",
      cetaceanShade2: "#091236",
      cetaceanShade3: "#080F2F",
      cetaceanShade4: "#070D28",
      cetaceanShade5: "#060B22",
      vividShade1: "#0084D5",
      vividShade2: "#0069AA",
      vividShade3: "#004F80",
      vividShade4: "#003555",
      vividShade5: "#001A2A",
      srpingShade1: "#00D583",
      srpingShade2: "#00AB69",
      srpingShade3: "#006B42",
      srpingShade4: "#005534",
      srpingShade5: "#002B1A",
      greenTransparent1: "rgb(178, 207, 99, 0.6)",
      greenShade1: "#889e4c",
      blueShade1: "#000e8c",
      orangeShade1: "#9c3206",
    },
    shade: {
      cetaceanTint1: "#152A81",
      cetaceanTint2: "#1F3FBF",
      cetaceanTint3: "#4564E1",
      cetaceanTint4: "#8398EB",
      cetaceanTint5: "#C1CBF5",
      vividTint1: "#40B6FF",
      vividTint2: "#55BEFF",
      vividTint3: "#80CEFF",
      vividTint4: "#AADFFF",
      vividTint5: "#D5EFFF",
      srpingTint1: "#2BFFAD",
      srpingTint2: "#56FFBE",
      srpingTint3: "#80FFCE",
      srpingTint4: "#AAFFDE",
      srpingTint5: "#D5FFEF",
    },
    feedbackState: {
      info: {
        default: "#40B6FF",
        darked: "#003555",
        hover: "#009EFF",
        active: "#0069AA",
        disabled: "#D5EFFF",
      },
      warning: {
        default: "#FFEA2B",
        darked: "#776B00",
        hover: "#EED700",
        active: "#B3A100",
        disabled: "#FFFBD5",
      },
      success: {
        default: "#00D583",
        darked: "#005534",
        hover: "#2BFFAD",
        active: "#00AB69",
        disabled: "#D5FFEF",
      },
      critical: {
        default: "#FF4141",
        darked: "#800000",
        hover: "#FF0101",
        active: "#C00000",
        disabled: "#FFD9D9",
      },
    },
  },
};

export default commonTheme;
